module.exports = __webpack_public_path__ + "img/logo_about.64aab7bc.svg";